<template>
  <div class="screen-rank-list" :class="{ 'layout-meeting': layout === 'meeting' }">
    <div class="rank-item-header flex" :class="headerClass">
      <div class="rank-item-name line-1" :class="nameHeaderClass">{{ displayNameLabel }}</div>
      <template v-if="isMultiColumn">
        <div class="rank-item-value" v-for="col in columns" :key="col.key">{{ col.label }}</div>
      </template>
      <div v-else class="rank-item-value">{{ valueLabel }}</div>
    </div>
    <vue-seamless-scroll :data="list" class="rank-scroll" :style="{ height: scrollHeight + 'px' }"
      :class-option="scrollOption">
      <div class="rank-item flex" :class="itemClass" v-for="(item, idx) in list" :key="idx">
        <div class="mr-auto" v-if="layout === 'meeting'">
          <div class="rank-item-name line-1" :class="[nameWidthClass]">{{ item[nameKey] }} </div>
        </div>
        <div class="rank-item-name line-1" :class="[nameWidthClass]" v-else>{{ item[nameKey] }}</div>
        <template v-if="isMultiColumn">
          <div class="rank-item-value" v-for="col in columns" :key="col.key">{{ item[col.key] }}</div>
        </template>
        <div v-else class="rank-item-value">{{ formatValue(item) }}</div>
      </div>
    </vue-seamless-scroll>
  </div>
</template>

<script>
export default {
  name: 'ScreenRankList',
  props: {
    /** 名称列标题（兼容旧用法，同 nameLabel） */
    title: { type: String, default: '' },
    /** 名称列标题 */
    nameLabel: { type: String, default: '' },
    /** 数值列标题（单列模式） */
    valueLabel: { type: String, default: '' },
    /** 多列配置，如 [{ key: 'sessions', label: '场次' }, ...]，有值时启用多列模式 */
    columns: { type: Array, default: () => [] },
    /** 数据列表 */
    list: { type: Array, default: () => [] },
    /** 可见条数，超出则滚动 */
    visibleCount: { type: Number, default: 5 },
    /** 名称字段 */
    nameKey: { type: String, default: 'name' },
    /** 数值字段（单列模式） */
    valueKey: { type: String, default: 'views' },
    /** 数值格式：simple-仅数值，withRate-数值(比率) */
    valueFormat: { type: String, default: 'simple' },
    /** 比率字段，valueFormat 为 withRate 时使用 */
    rateKey: { type: String, default: 'rate' },
    /** 名称列宽度类名，如 w-100 line-1 */
    nameWidthClass: { type: String, default: '' },
    /** 布局：default-两列左对齐，meeting-多列右对齐（会议统计样式） */
    layout: { type: String, default: 'default' }
  },
  computed: {
    isMultiColumn() {
      return this.columns && this.columns.length > 0
    },
    displayNameLabel() {
      return this.nameLabel || this.title
    },
    headerClass() {
      return this.isMultiColumn && this.layout === 'meeting' ? '' : 'row-between'
    },
    nameHeaderClass() {
      return this.layout === 'meeting' ? '' : 'line-1'
    },
    itemClass() {
      return this.layout === 'meeting' ? '' : 'row-between'
    },
    scrollHeight() {
      const itemHeight = 27
      return this.visibleCount * itemHeight - 9
    },
    scrollOption() {
      return {
        step: 0.3,
        limitMoveNum: this.visibleCount,
        hoverStop: true,
        direction: 1,
        openWatch: true,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 1000
      }
    }
  },
  methods: {
    formatValue(item) {
      const val = item[this.valueKey]
      if (this.valueFormat === 'withRate' && item[this.rateKey] !== undefined) {
        return `${val}(${item[this.rateKey]})`
      }
      return val
    }
  }
}
</script>

<style lang="scss" scoped>
.screen-rank-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  line-height: 16px;

  .rank-item-header {
    font-size: 14px;
    display: flex;
    justify-content: space-between;
  }

  .rank-scroll {
    overflow: hidden;

    ::v-deep>div {
      display: flex;
      flex-direction: column;
      gap: 9px;
    }
  }

  .rank-item {
    padding-bottom: 9px;
    line-height: 18px;
    font-size: 14px;
    gap: 10px;
    display: flex;
    justify-content: space-between;

    .rank-item-name {
      padding: 0 2px;
      border-radius: 2px;
      height: 18px;
      display: inline-block;
      box-sizing: border-box;
      background: linear-gradient(to right, #E323FF, #7517F8);

      &.w-100 {
        width: 100px;
      }

      &.line-1 {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .rank-item-value {
      flex-shrink: 0;
    }

    &:last-child {
      padding-bottom: 0;
    }
  }

  &.layout-meeting {
    .rank-item-header {
      justify-content: flex-end;

      .rank-item-name {
        margin-right: auto;
        flex: 2;
      }

      .rank-item-value {
        flex: 1;
        text-align: right;
      }
    }

    .rank-item {
      justify-content: flex-end;

      .rank-item-name,
      .mr-auto {
        flex: 2;
        margin-right: auto;
      }

      .rank-item-value {
        flex: 1;
        text-align: right;
      }
    }
  }
}
</style>
